import { animated } from '@react-spring/web';

import Box from 'components/Box';

export default animated(Box);
